var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "gray"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.95 14.432c.273-.271.642-.426 1.028-.432.199-.003.396.034.58.108.185.074.352.185.493.324l8.492 8.44c.143.135.257.298.335.479.078.18.12.374.122.57.002.197-.035.392-.11.574-.075.182-.185.347-.325.486-.14.14-.306.249-.49.323-.183.075-.379.112-.577.11-.197-.002-.393-.044-.574-.122-.182-.078-.346-.19-.483-.332l-5.928-5.892v13.42c0 .835-.678 1.512-1.513 1.512-.835 0-1.513-.677-1.513-1.513V19.068L16.56 24.96c-.137.141-.301.255-.483.332-.181.078-.377.12-.575.122-.197.002-.393-.036-.576-.11-.184-.074-.35-.184-.49-.323s-.25-.304-.325-.486c-.074-.182-.112-.377-.11-.573.002-.197.044-.39.122-.571.079-.18.192-.344.335-.48l8.492-8.439z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollTop);
export default __webpack_public_path__ + "static/media/scroll-top.bd67a208b392ec3408c4f633257a7a5a.svg";
export { ForwardRef as ReactComponent };